import { headerApiService } from "../api-services/headerApiServices";
import { userDetails } from "../store/user-details/slice";

export const fetchSessionDetails = async (dispatch) => {
    try {
        const sessionDetails = await headerApiService.getSessionDetails();

        if (sessionDetails?.data) {
            dispatch(userDetails(sessionDetails?.data));
        }
        return sessionDetails;
    } catch (error) {
        console.error("Failed to fetch session details:", error);
        throw error;
    }
};
